module.exports = __webpack_public_path__ + "img/special_moisturegel_202402.f29b306b.jpg";